// Initialise Sentry error tracking as a side effect before the React tree
// mounts. PostHog is NOT initialised here — it is gated behind cookie consent
// and initialised in App.tsx once the user has accepted analytics cookies.
import '@/lib/sentry';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

createRoot(document.getElementById('root')!).render(<App />);
